/**
 * Checks if there are any active panel filters by examining URL parameters
 * Only checks panel filter parameters, not basic search fields (userId, subjectId) or pagination
 * Excludes default date range values from being considered as active filters
 */
export const hasActiveFilters = (): boolean => {
  const searchParams = new URLSearchParams(window.location.search);

  // Panel filter parameter keys (excluding userId, subjectId, page, pageSize)
  const panelFilterKeys = ['contentTypes', 'labels', 'languages', 'topics', 'metadata', 'policyFilter'];

  // Check non-date filters first
  const hasNonDateFilters = panelFilterKeys.some(key => searchParams.has(key));

  if (hasNonDateFilters) {
    return true;
  }

  // Check date filters - only consider them active if they're not the default range
  const hasStartDate = searchParams.has('startDate');
  const hasEndDate = searchParams.has('endDate');

  if (hasStartDate || hasEndDate) {
    // If we have date parameters in URL, they're considered active
    // (since we only put non-default dates in URL)
    return true;
  }

  // Check sampling filter - only consider it active if it's not the default value
  const hasSampling = searchParams.has('isSampled');

  if (hasSampling) {
    // If we have sampling parameter in URL, it's considered active
    // (since we only put non-default sampling values in URL)
    return true;
  }

  return false;
};
